import { useEffect, useState } from "react";
import { getPublicProjects } from "./publicProjectsApi";

export default function usePublicProjects() {
  const [projects, setProjects] = useState([]);
  const [page, setPage] = useState(0);
  const [attempt, setAttempt] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [hasNext, setHasNext] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError("");
    getPublicProjects(page, controller.signal).then((result) => {
      if (controller.signal.aborted) return;
      setProjects((previous) => page === 0 ? result.projects : [...previous, ...result.projects.filter((item) => !previous.some((existing) => existing.id === item.id))]);
      setHasNext(result.hasNext);
    }).catch(() => {
      if (!controller.signal.aborted) setError("We couldn't load projects. Please try again.");
    }).finally(() => {
      if (!controller.signal.aborted) setLoading(false);
    });
    return () => controller.abort();
  }, [page, attempt]);
  return { projects, loading, error, hasNext, loadMore: () => setPage((value) => value + 1), retry: () => setAttempt((value) => value + 1) };
}
